import { Component, EventEmitter, Input, Output } from '@angular/core';
import { QuickFilterItem } from '../service/quick-filters.service';

@Component({
  selector: 'rmb-quick-filters-search',
  standalone: false,
  templateUrl: './quick-filters-search.component.html',
  styleUrl: './quick-filters-search.component.scss',
})
export class QuickFiltersSearchComponent {
  @Input() quickFiltersList: QuickFilterItem[];
  @Input() showSearch?: boolean;
  @Input() activeFilter?: number;
  @Input() isAdmin = true;
  @Output() searchClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() resetClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() quickFiltersClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() filterSelect = new EventEmitter<{ data: QuickFilterItem; index: number }>();

  onFilterSelect(data: QuickFilterItem, index: number): void {
    this.filterSelect.emit({ data, index });
  }

  onSearch() {
    this.searchClicked.emit();
  }

  quickFilter() {
    this.quickFiltersClicked.emit();
  }

  onReset() {
    this.resetClicked.emit();
  }

  isTextTruncated(element: HTMLElement): boolean {
    return element.scrollWidth > element.clientWidth;
  }
}
